<template>
    <div>
        <a-card title="日志分析" >
            <v-gobackbutton slot="extra" >返回</v-gobackbutton>
            <div style="margin-bottom:18px;">
                <div>
                    <envSelecter v-model="selectedEnv" style="display:inline-flex;"></envSelecter>
                    <sysSelecter v-model="sleectedSys" style="display:inline-flex;"></sysSelecter>
                    <timeSelecter v-model="selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                    
                </div>
            </div>

            <searchForm @handleSearchChange="handleSubmit"></searchForm>


            <a-row :gutter="[16,16]">
                <a-col :span='24'>
                   <logTable ref="logTableID"  :style="{width:tableWidth}"></logTable>
                </a-col>
            </a-row>
        </a-card>

    </div>
</template>

<script>
import searchForm from './searchForm'
import sysSelecter from '../components/sysSelecter'
import envSelecter from '../components/envSelecter'
import timeSelecter from '../components/timeselecter'
import logTable from './logTable'

export default {
    data(){
        return {
            sleectedSys:'',
            selectedEnv:'',
            selectedTimeRange:'',
            tableWidth:'800px',
        }
    },
    methods:{
        handleSubmit(searchP){
            searchP.sleectedSys = this.sleectedSys;
            searchP.selectedEnv = this.selectedEnv;
            searchP.selectedTimeRange = this.selectedTimeRange;
            this.$refs.logTableID.searchP = searchP;
            this.$refs.logTableID.pagenation.current = 1;
            this.$refs.logTableID.loadData();
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    mounted(){
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);
    },
    components:{
        timeSelecter,
        sysSelecter,
        envSelecter,
        logTable,
        searchForm
    }
};
</script>

<style lang="less" scoped>
</style>
<style>

</style>